import _ from "lodash";
import { handleTableSorter, checkIsParent } from "utils/helpers";

/**
 * Sorts an array of nodes and their child nodes recursively based on the provided sorting criteria.
 * The function first sorts the current nodes and then checks for any parent nodes that contain child items.
 * It will recursively sort those child items as well.
 *
 * @param {Array} nodes - The array of nodes to be sorted.
 * @param {string} sortLabel - The field by which the nodes should be sorted.
 * @param {string} sortSep - The sorting order (e.g., ascending or descending).
 */
export function sortNodesAndChildren(nodes, sortLabel, sortSep) {
  nodes.sort(handleTableSorter(sortLabel, sortSep));
  nodes.forEach(function (node) {
    if (checkIsParent(node)) {
      sortNodesAndChildren(node.childitems, sortLabel, sortSep);
    }
  });
}

/**
 * Sorts a table based on a specified field and order, and returns a sorted copy of the table.
 * The function first clones the table to avoid modifying the original data, then calls the
 * sortNodesAndChildren function to sort the data, including any nested child items.
 *
 * @param {Array} table - The array representing the table of data to be sorted.
 * @param {string} sortField - The field by which the table should be sorted.
 * @param {string} sortSep - The sorting order (e.g., ascending or descending).
 * @returns {Array} - The sorted table.
 */
export const sortTable = (table, sortField, sortSep) => {
  // if table and variTable exist and are arrays
  const tempTable = Array.isArray(table) ? _.cloneDeep(table) : [];

  // Sort the data
  sortNodesAndChildren(tempTable, sortField, sortSep);

  return tempTable;
};
